import global from "./config/Global.json"

export function getAPI(API_NAME) {
    return global.api.host + global.api[API_NAME];
}

export function getHost() {
    return global.api.host;
}